import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter as Router, useHistory} from 'react-router-dom';
import {getRequest} from "./util/APIUtils"

import {REACT_PATH, VirtualHost} from './constants';
import {showAxiosError} from "./util/Helpers";
import NotFound from "./component/NotFound";
import {ConfigProvider} from "antd";
import Tr_TR_Locale from "antd/es/locale/tr_TR"

getRequest(`/virtual/conf`)
    .then(response => {
        Object.assign(VirtualHost, response.data);
        if (response && response.data) {
            document.title = response.data.companyAddressName;
        }

        ReactDOM.render(
            <Router basename={REACT_PATH} keySize={36}>
                <ConfigProvider locale={Tr_TR_Locale}>
                    <App />
                </ConfigProvider>
            </Router>,
            document.getElementById('root')
        );
    })
    .catch(exception => {
        if (exception && exception.response && exception.response.status === 404) {
            ReactDOM.render(
                <Router basename={REACT_PATH} keySize={36}>
                    <NotFound/>
                </Router>,
                document.getElementById('root')
            );
        } else {
            showAxiosError(exception)
        }
    });

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js